/*************************************************/
/* PACKAGES                                      */
/*************************************************/

export function packages() {
    const packageSelector = ".package";
    const contentSelector = ".package__content";
    const toggleSelector = ".package__toggle";
    const collapsibleClass = "package--collapsible";
    const expandedClass = "package--expanded";
    const mobileQuery = window.matchMedia("(max-width: 768px)");

    const cards = document.querySelectorAll(packageSelector);
    if (cards.length === 0) {
        return;
    }

    const update = (card) => {
        const content = card.querySelector(contentSelector);
        const toggle = card.querySelector(toggleSelector);
        if (content == null || toggle == null || card.classList.contains(expandedClass)) {
            return;
        }

        card.classList.remove(collapsibleClass);
        toggle.hidden = true;

        if (mobileQuery.matches && content.scrollHeight > content.clientHeight) {
            card.classList.add(collapsibleClass);
            toggle.hidden = false;
        }
    };

    const updateAll = () => cards.forEach(update);

    cards.forEach(card => {
        const toggle = card.querySelector(toggleSelector);
        if (toggle == null) {
            return;
        }

        toggle.addEventListener("click", () => {
            card.classList.add(expandedClass);
            card.classList.remove(collapsibleClass);
            toggle.setAttribute("aria-expanded", "true");
            toggle.hidden = true;
        });
    });

    let resizeTimer;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateAll, 150);
    });
    mobileQuery.addEventListener("change", updateAll);

    updateAll();
    // Web fonts change text height after first paint.
    document.fonts?.ready.then(updateAll);
}
